// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__d-rwo","log":"ModalInventoryLogs_log__2FBwu","date":"ModalInventoryLogs_date__2ibAy","userName":"ModalInventoryLogs_userName__2E05h"};